import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'invalid-token',
  templateUrl: './invalid-token.component.html',
  styleUrls: ['./invalid-token.component.scss']
})
export class InvalidTokenComponent {

  constructor(private router: Router) {
  }

  ngOnInit(): void {

  }

  top() {
    this.router.navigate(['carry-reserve'])
  }
}
